import { Text, Title } from '@components/forms/InputPartials.tsx';
import type { ReactElement } from 'react';
const SubmitMessage = ({ title, text }: { title: string; text: string }): ReactElement => {
  return (
    <div className="tw-flex tw-gap-8 tw-justify-center tw-flex-col tw-h-full tw-content-center">
      <div className="tw-mx-auto">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={72}
          height={72}
          viewBox="0 0 72 72"
          fill="none"
        >
          <path
            d="M66 33.2401V36.0001C65.9963 42.4693 63.9015 48.7641 60.028 53.9456C56.1545 59.127 50.7099 62.9175 44.5061 64.7518C38.3023 66.586 31.6718 66.3658 25.6034 64.1238C19.535 61.8819 14.354 57.7384 10.8329 52.3113C7.3118 46.8842 5.63937 40.4643 6.06503 34.009C6.49069 27.5538 8.99162 21.4091 13.1948 16.4913C17.3981 11.5735 23.0784 8.14623 29.3886 6.72052C35.6988 5.29481 42.3008 5.94709 48.21 8.58008"
            stroke="#05DE34"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27 33L36 42L66 12"
            stroke="#05DE34"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <Title className={'tw-text-center'}>{title}</Title>
      <Text className={'tw-text-center tw-mb-6'}>{text}</Text>
    </div>
  );
};

export { SubmitMessage };
